(() => {
  const roots = '.tns-slider, .splide, #banner_slider, .fav-slider, .tutorial-slider';
  const slides = '.tns-item, .splide__slide';
  const observed = new WeakSet();

  function sync(root) {
    root.querySelectorAll(slides).forEach(slide => {
      const splide = slide.closest('.splide');
      // Splide 2 leaves initially offscreen slides without aria-hidden.
      // Its visibility class is authoritative after mount; before mount leave content usable.
      const offscreen = slide.matches('.splide__slide') && splide?.classList.contains('is-active')
        && !slide.classList.contains('is-visible');
      slide.inert = slide.getAttribute('aria-hidden') === 'true' || Boolean(offscreen);
    });
  }

  function observe(root) {
    if (observed.has(root)) return;
    observed.add(root);
    sync(root);
    // These libraries update visibility after navigation, autoplay and resize.
    // Watching their roots also covers slides inserted or initialized later.
    new MutationObserver(() => sync(root)).observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class'],
    });
  }

  function init(scope) {
    if (scope.matches?.(roots)) observe(scope);
    scope.querySelectorAll(roots).forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
